import { type PollsDataSource, type SavePollParams, type UpdatePollParams } from '../../data/polls.datasource'
import { type PollDetail, type SavePollInput, type UpdatePollInput } from '../models/poll.model'

const fromEntity = (e: import('../../data/entities/poll.entity').PollEntity): PollDetail => ({
  id: e.id,
  uuid: e.uuid,
  postId: e.postId,
  question: e.question,
  state: e.state,
  totalVotes: e.totalVotes,
  closesAt: new Date(e.closesAt),
  closedAt: e.closedAt ? new Date(e.closedAt) : null,
  options: e.options.map((o) => ({
    id: o.id,
    text: o.text,
    order: o.order,
    voteCount: o.voteCount
  }))
})

export class SavePollInteractor {
  constructor(private readonly dataSource: PollsDataSource) {}

  async create(input: SavePollInput): Promise<PollDetail> {
    const params: SavePollParams = {
      postId: input.postId,
      question: input.question,
      closesAt: input.closesAt.toISOString(),
      options: input.options
    }
    return fromEntity(await this.dataSource.create(params))
  }

  async update(postId: number, input: UpdatePollInput): Promise<PollDetail> {
    const params: UpdatePollParams = {
      question: input.question,
      closesAt: input.closesAt?.toISOString(),
      options: input.options
    }
    return fromEntity(await this.dataSource.update(postId, params))
  }
}
